import * as Sentry from '@sentry/browser'
import store from '@/store'

import Router from 'vue-router'
const { isNavigationFailure } = Router

export function sentryConfigureScope(level = 'error') {
    if (process.env.VUE_APP_ENV !== 'local') {
        const workspace = JSON.parse(localStorage.getItem('workspace'))

        Sentry.configureScope(scope => {
            scope.setLevel(level)
            scope.setUser({
                id: store.state.user.userId,
                username: store.state.user.userName,
                email: store.state.user.userEmail,
                workspaceId: workspace ? workspace.workspaceId : null
            })
        })
    }
}

export function errorHandler(error, level) {
    if (isNavigationFailure(error)) {
        store.dispatch('toggleMainLoader', false)
    }

    if (process.env.VUE_APP_ENV !== 'local') {
        // Conditions for not reporting errors
        if (
            typeof error.response !== 'undefined'
            && (
                error.response.status === 401 ||
                error.response.status === 403 ||
                (error.response.status === 400 && error.response.data.errorCode) // If response contains error code it means that this is not an unexpected error
            )
        ) {
            return
        }

        sentryConfigureScope(level)

        if (error.isAxiosError) {
            Sentry.withScope(scope => {
                if (error.config.url === '/users/token') return // Prevent error reporting if login or password is incorrect

                let payload = null

                typeof error.response === 'undefined' ? payload = null : payload = error.response.data

                scope.setFingerprint(['', error.config.url])
                scope.setExtra('API response', payload)
                Sentry.captureException(error)
            })
        } else {
            Sentry.captureException(error)
        }
    } else {
        console.error(error)
    }
}

export function addSentryBreadcrumb(category, message, data, level) {
    Sentry.addBreadcrumb({
        category: category,
        message: message,
        data: data,
        level: level
    })
}